export let wxshare = (res) => {
  window._wx.ready(() => {
    console.log('------wxready------')
    window._wx.updateAppMessageShareData({
      title: res.title, // 分享标题
      desc: res.desc || '研值圈', // 分享描述
      link: res.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: res.imgUrl || 'https://static-object.hjbxjz.com/login_logo.png', // 分享图标
      success: () => {
        // 设置成功
        console.log('设置成功1')
      }
    })

    window._wx.updateTimelineShareData({
      title: res.title, // 分享标题
      desc: res.desc || '研值圈', // 分享描述
      link: res.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: res.imgUrl || 'https://static-object.hjbxjz.com/login_logo.png', // 分享图标
      success: () => {
        // 设置成功
        console.log('设置成功2')
      }
    })
  })

  window._wx.error((error) => {
    console.log('------wxready------', error)
  })
}
